import { Box, InputAdornment, Slider, TextField, Typography } from "@mui/material";
import { AnthropometrySnapshot, macroGPerKgToGramsRounded } from "@notemeal/shared-utils-macro-protocol";
import { trackEvent } from "apps/web/src/reporting/reporting";
import { Dispatch } from "react";
import { EditMacroProtocolAction, EditMacroState } from "shared-ui/reducers/EditMacroProtocol";
import { GRAM_WIDTH, PERCENT_WIDTH } from "./MacrosTargets";

interface MacroInputProps {
  macro: "cho" | "pro" | "fat";
  state: EditMacroState;
  anthropometrySnapshot: AnthropometrySnapshot;
  dispatch: Dispatch<EditMacroProtocolAction>;
  gPerKgOnly: boolean;
}

// TODO: Metric Hotfix not 100% sure this is right
export const MacroInput = ({ macro, state, anthropometrySnapshot, dispatch, gPerKgOnly }: MacroInputProps) => {
  const grams = macroGPerKgToGramsRounded(state, anthropometrySnapshot.weight);
  const color = macro === "cho" ? "cho.main" : macro === "pro" ? "pro.main" : "fat.main";

  return (
    <Box sx={{ display: "flex", gap: 1, alignItems: "center" }} aria-label={`Select ${macro} slider target`}>
      <Typography sx={{ width: 45, color, fontWeight: "500" }} id={macro}>{macro.toUpperCase()}</Typography>
      <Slider
        sx={{ width: 200, mr: 1 }}
        min={0}
        max={100}
        step={1}
        value={state.percent}
        aria-label={`${macro} ${state.percent}% target`}
        onChange={(e, value) => {
          trackEvent(`Nutrition | Team | Athlete | Create Meal Plan | Select ${macro} Slider Target`, { macro, value });
          value !== null &&
            dispatch({
              type: "CHANGE_MACRO_PERCENT",
              payload: {
                macro: macro,
                value: `${value}`,
              },
            });
        }}
        aria-labelledby={macro}
      />
      <TextField
        sx={{
          width: PERCENT_WIDTH,
          minWidth: PERCENT_WIDTH,
          mt: 0,
          ".MuiInputBase-root": { backgroundColor: !gPerKgOnly && state.usesPercent ? "info.lighter" : "inherit" },
        }}
        type="number"
        inputProps={{ 'aria-labelledby': macro }}
        value={gPerKgOnly ? "" : state.percentInput}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end" variant="filled">
              <Typography variant="body2">%</Typography>
            </InputAdornment>
          ),
        }}
        onChange={event => {
          trackEvent(`Nutrition | Team | Athlete | Create Meal Plan | Select ${macro} % Target`, { macro, value: event.target.value });
          dispatch({
            type: "CHANGE_MACRO_PERCENT",
            payload: {
              macro: macro,
              value: event.target.value,
            },
          });
        }}
        disabled={gPerKgOnly}
      />
      <TextField
        sx={{
          maxWidth: 115,
          mt: 0,
          ".MuiInputBase-root": { backgroundColor: gPerKgOnly || !state.usesPercent ? "info.lighter" : "inherit" },
        }}
        type="number"
        inputProps={{ step: 0.05, 'aria-labelledby': macro }}
        value={state.gPerKGInput}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <Typography variant="body2">g/kg</Typography>
            </InputAdornment>
          ),
        }}
        onChange={event => {
          trackEvent(`Nutrition | Team | Athlete | Create Meal Plan | Select ${macro} g/kg Target`, { macro, value: event.target.value });
          dispatch({
            type: "CHANGE_MACRO_G_PER_KG",
            payload: {
              macro: macro,
              value: event.target.value,
            },
          });
        }}
      />
      <Typography sx={{ width: GRAM_WIDTH }}>{grams}g</Typography>
    </Box>
  );
};
